/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI'
], (APIFactory, PropertiesProviderAPI) => {
	class ContentProperties {
		constructor({ features, options }) {
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			this._options = options;
			this._propertyList =  options && options.propertyList ? JSON.parse(JSON.stringify(options.propertyList)) : [];
			features.Properties.registerProvider(this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		getPropertyLayoutList() {
			if (!this._propertyLayoutList) {
				this._propertyLayoutList =  this._options && this._options.propertyLayoutList ? this._options.propertyLayoutList : [];
			}
			return this._propertyLayoutList;
		}

		getPropertyList() {
			return this._propertyList;
		}

		reset() { }
	}

	return ContentProperties;
});